import { render, staticRenderFns } from "./Missions.vue?vue&type=template&id=180af620&"
import script from "./Missions.vue?vue&type=script&lang=js&"
export * from "./Missions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports